import { render } from "./CommsPreferences.vue?vue&type=template&id=7b8729e8&scoped=true"
import script from "./CommsPreferences.vue?vue&type=script&lang=js"
export * from "./CommsPreferences.vue?vue&type=script&lang=js"

import "./CommsPreferences.vue?vue&type=style&index=0&id=7b8729e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8729e8"]])

export default __exports__